export default "__VITE_ASSET__43654dfe__"